var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94661 5.0529C5.25035 4.74916 5.74281 4.74916 6.04655 5.0529L14.8461 13.8525C15.1498 14.1562 15.1498 14.6487 14.8461 14.9524V14.9524C14.5424 15.2561 14.0499 15.2561 13.7462 14.9524L4.94661 6.15285C4.64287 5.8491 4.64287 5.35664 4.94661 5.0529V5.0529Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8529 5.05403C15.1566 5.35777 15.1566 5.85023 14.8529 6.15398L6.05331 14.9535C5.74957 15.2573 5.25711 15.2573 4.95336 14.9535V14.9535C4.64962 14.6498 4.64962 14.1573 4.95336 13.8536L13.7529 5.05403C14.0567 4.75029 14.5491 4.75029 14.8529 5.05403V5.05403Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.a110ceca039408996613be70991885d8.svg";
export { ForwardRef as ReactComponent };